module.exports = __webpack_public_path__ + "static/Mobile_3@2x-6fea10304a16eb32049383c790936fa3.png";